import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import AccountingAuditingTemplate from "components/templates/offshore/accounting-and-auditing";

import dataStatic from "./data.json";

export default function Home({ data }) {
  return (
    <Layout locationRouter="offshore" page={data?.page}>
      <AccountingAuditingTemplate data={dataStatic} posts={data?.posts} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const locale = "offshore";
  const uri = "/accounting-and-auditing";
  const page = await fetchSeo({
    uri,
    locale,
  });

  const posts = await fetchPosts({
    postPerPage: 20,
    gqlNode: `
    categories {
      nodes {
        name
        uri
        parent {
          node {
            id
          }
        }
      }
    }`,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts?.nodes || [],
      },
      revalidate: 1,
    },
  };
};
